module.exports = false;


//////////////////
// WEBPACK FOOTER
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 3